import { Link, useLocation } from "react-router-dom";

interface NavLinksProps {
  isMobile?: boolean;
  onMobileItemClick?: () => void;
}

const NavLinks = ({ isMobile = false, onMobileItemClick }: NavLinksProps) => {
  const location = useLocation();

  // Refined isActive for more precise matching including listing_type
  const isLinkActive = (path: string, listingType: string) => {
    const params = new URLSearchParams(location.search);
    return (
      location.pathname === path && params.get("listing_type") === listingType
    );
  };

  const baseMobileClassName =
    "block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-propertylk-blue hover:bg-gray-50 transition duration-150 ease-in-out";

  const handleClick = () => {
    if (isMobile && onMobileItemClick) {
      onMobileItemClick();
    }
  };

  return (
    <>
      <Link
        to="/properties?listing_type=sale&page=1"
        className={
          isMobile
            ? baseMobileClassName
            : `px-3 py-2 font-medium text-sm rounded-md transition-colors duration-200 ${
                isLinkActive("/properties", "sale")
                  ? "text-propertylk-blue"
                  : "text-gray-600 hover:text-propertylk-blue"
              }`
        }
        onClick={handleClick}
      >
        Buy
      </Link>
      <Link
        to="/properties?listing_type=rent&page=1"
        className={
          isMobile
            ? baseMobileClassName
            : `px-3 py-2 font-medium text-sm rounded-md transition-colors duration-200 ${
                isLinkActive("/properties", "rent")
                  ? "text-propertylk-blue"
                  : "text-gray-600 hover:text-propertylk-blue"
              }`
        }
        onClick={handleClick}
      >
        Rent
      </Link>
      {/*
      <Link
        to="/properties?listing_type=lease&page=1"
        className={
          isMobile
            ? baseMobileClassName
            : `px-3 py-2 font-medium text-sm rounded-md transition-colors duration-200 ${
                isLinkActive("/properties", "lease")
                  ? "text-propertylk-blue"
                  : "text-gray-600 hover:text-propertylk-blue"
              }`
        }
        onClick={handleClick}
      >
        Lease
      </Link>
      */}
      {/*
      <Link
        to="/market-data"
        className={
          isMobile
            ? baseMobileClassName
            : `px-3 py-2 font-medium text-sm rounded-md transition-colors duration-200 ${
                location.pathname === "/market-data"
                  ? "text-propertylk-blue"
                  : "text-gray-600 hover:text-propertylk-blue"
              }`
        }
        onClick={handleClick}
      >
        Market Data
      </Link>
      */}
      {/*
      <Link
        to="/property-pulse"
        className={
          isMobile
            ? baseMobileClassName
            : `px-3 py-2 font-medium text-sm rounded-md transition-colors duration-200 ${
                location.pathname === "/property-pulse"
                  ? "text-propertylk-blue"
                  : "text-gray-600 hover:text-propertylk-blue"
              }`
        }
        onClick={handleClick}
      >
        Property Pulse
      </Link>
      */}
      <Link
        to="/about"
        className={
          isMobile
            ? baseMobileClassName
            : `px-3 py-2 font-medium text-sm rounded-md transition-colors duration-200 ${
                location.pathname === "/about"
                  ? "text-propertylk-blue"
                  : "text-gray-600 hover:text-propertylk-blue"
              }`
        }
        onClick={handleClick}
      >
        About
      </Link>
      <Link
        to="/contact"
        className={
          isMobile
            ? baseMobileClassName
            : `px-3 py-2 font-medium text-sm rounded-md transition-colors duration-200 ${
                location.pathname === "/contact"
                  ? "text-propertylk-blue"
                  : "text-gray-600 hover:text-propertylk-blue"
              }`
        }
        onClick={handleClick}
      >
        Contact Us
      </Link>
    </>
  );
};

export default NavLinks;
